/**
 * The band that closes one manager's block before the next one begins.
 *
 * A manager row, the projects it opens into and the tickets under those are four levels of the same
 * indent, so where one manager ends and the next starts is not visible from the rows themselves.
 * This is drawn rather than inferred.
 *
 * It carries no day strip: it stands for nobody, so there is nothing to show across the window. The
 * left edge is marked at the same two pixels a manager or a project row marks its own, so the
 * column of accents down the board is unbroken — in grey, because the separator belongs to no one.
 */
export function CapacityManagerSeparatorRow() {
	/** Render */
	return (
		<div className="w-full h-[2px] shrink-0 bg-gray-300 border-l-2 border-l-gray-400 dark:bg-zinc-800 dark:border-l-zinc-600" />
	);
}
